import axios from 'axios';

export default class Client {
  constructor(options, storage) {
    this.storage = storage;
    this.options = options;

    axios.defaults.baseURL = options.baseUrl;
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    axios.interceptors.response.use(null, async error => {
      if (error.config && error.response && error.response.status === 401) {
        if (error.config.data && error.config.data.includes('refreshToken')) {
          return Promise.reject(error);
        }

        const refreshToken = await this.storage.getItem(this.options.refreshTokenKey);

        let token = {};

        const request = await axios({
          method: 'post',
          data: {
            refreshToken
          },
          responseType: 'json',
          url: '/account/refresh',
          baseURL: this.options.baseUrl
        });

        token = request.data;

        await this.storage.setItem(this.options.accessTokenKey, token.accessToken);

        if (token.refreshToken) {
          this.storage.setItem(this.options.refreshTokenKey, token.refreshToken);
        }

        // eslint-disable-next-line no-param-reassign
        error.config.headers.Authorization = `Bearer ${token.accessToken}`;
        return axios.request(error.config);
      }

      return Promise.reject(error);
    });
  }

  async request(url, method, data, headers, refreshEndpoint) {
    const options = {
      data,
      headers,
      method,
      responseType: 'json',
      url
    };

    try {
      const response = await axios(options);

      return Promise.resolve(this.getResponse(response));
    } catch (error) {
      if (error.response && error.response.status === 401 && refreshEndpoint) {
        refreshEndpoint().then(async accessToken => {
          options.headers = accessToken;
          const response = await axios(options);
          return Promise.resolve(this.getResponse(response));
        });
      } else if (!error.json) {
        return Promise.reject(this.getResponse({ error, status: -1 }));
      }

      const errorText = error.text();

      return Promise.reject(this.getResponse(error, errorText));
    }
  }

  // eslint-disable-next-line class-methods-use-this
  getResponse(response, text = '') {
    if (response && response.error) {
      const { error } = response;

      return {
        body: error.response.data,
        headers: error.response.headers,
        status: error.response.status
      };
    }

    return {
      body: response ? response.data : text,
      headers: response ? response.headers : {},
      status: response ? response.status : 200
    };
  }
}
